import { FIELD_TYPES } from "constants/template-field-type";
import assetFieldsConfig from "components/core/asset/fields-config";
import ThemeConfig from "segments/core-configs/theme-config";

export default {
  type: FIELD_TYPES.NESTED,
  label: "Fade In",
  fields: {
    ...ThemeConfig,
    backgroundAsset: {
      type: FIELD_TYPES.NESTED,
      label: "Background image",
      fields: assetFieldsConfig
    },
    fadeInAsset: {
      type: FIELD_TYPES.NESTED,
      label: "Fade-in image",
      fields: {
        width: { type: FIELD_TYPES.TEXT, label: "Width" },
        ...assetFieldsConfig
      }
    }
  }
};
